import { TariffCategory, TariffStatusType } from '../../shared/models/types'
import { WallboxTariffResponseDto } from '../api/dto/wallbox.dto'
import { TariffModel } from '../models/wallbox-model'
import { getStaticPrices } from './get-static-prices'

/**
 * Function for getting one tariff data
 * @param tariff - tariff as TariffCoreDto
 * @param tariffStatus - tariff status as TariffStatusType
 * @returns - tariff as TariffModel
 */
export const getTariff = (tariff: WallboxTariffResponseDto, tariffStatus: TariffStatusType): TariffModel => {
  /* solar price for dynamic prices:
    - solar price is defined as type FLAT
    - solar price for dynamic prices is defined in only one price_component element
    - it is valid for price_component element if exists in at least one element
    - FE checks for that rule and display solar price from that element
    - if there are no type FLAT or solar prices, FE display 0 as valid solar price
    */
  const validDynamicSolarPrice =
    tariff.category === TariffCategory.dynamicTariff &&
    tariff.tariff.elements.flatMap(element => element.price_components).find(price => price.type === 'FLAT')

  return {
    tariffId: tariff.tariff.id,
    tariffName: tariff.name,
    tariffCategory: tariff.category,
    currencyCode: tariff.tariff.currency,
    startTime: tariff.tariff.start_date_time ? tariff.tariff.start_date_time : null,
    endTime: tariff.tariff.end_date_time ? tariff.tariff.end_date_time : null,
    tariffStatus: tariffStatus,
    dischargePrice: tariff.dischargePrice || 0,
    staticPrices: { gridPrice: getStaticPrices(tariff).grid, solarPrice: getStaticPrices(tariff).solar },
    dynamicPrices:
      tariff.category === TariffCategory.dynamicTariff
        ? tariff.tariff.elements.map(element => {
            return {
              gridPrice: element.price_components.map(price => price.type === 'ENERGY' && price.price)[0] || 0,
              solarPrice: validDynamicSolarPrice ? validDynamicSolarPrice.price : 0,
              startDateTime: element.restrictions?.start_date_time,
              endDateTime: element.restrictions?.end_date_time,
            }
          })
        : [],
  }
}
